import { useEffect, useRef, useState } from "react"
import { cn } from "@utils/tw"
import { TabButton } from "./TabButton"

export const InlineVideo = ({ src, className }: { src: string; className?: string }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null)
  const [playing, setPlaying] = useState(true)

  useEffect(() => {
    if (videoRef.current) {
      if (playing) {
        videoRef.current.play()
      } else {
        videoRef.current.pause()
      }
    }
  }, [playing])

  return (
    <div className={cn("w-full relative", className)}>
      <video ref={videoRef} className="w-full h-auto" autoPlay={playing} loop muted playsInline>
        <source src={src} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <TabButton className="absolute right-2 bottom-2" onClick={() => setPlaying(!playing)}>
        <div className="size-6 p-2 text-white bg-black/50">
          {playing ? (
            <svg className="w-full" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.75 3C5.33579 3 5 3.33579 5 3.75V16.25C5 16.6642 5.33579 17 5.75 17H7.25C7.66421 17 8 16.6642 8 16.25V3.75C8 3.33579 7.66421 3 7.25 3H5.75Z"
                fill="currentColor"
              />
              <path
                d="M12.75 3C12.3358 3 12 3.33579 12 3.75V16.25C12 16.6642 12.3358 17 12.75 17H14.25C14.6642 17 15 16.6642 15 16.25V3.75C15 3.33579 14.6642 3 14.25 3H12.75Z"
                fill="currentColor"
              />
            </svg>
          ) : (
            <svg className="w-full" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 7.40825C6 6.33866 7.14675 5.66062 8.08395 6.17607L16.7394 10.9366C17.7108 11.4708 17.7108 12.8667 16.7394 13.4009L8.08395 18.1614C7.14675 18.6769 6 17.9988 6 16.9292V7.40825Z"
                fill="currentColor"
              />
            </svg>
          )}
        </div>
      </TabButton>
    </div>
  )
}
